__turbopack_context__.v({
  "modalRoot": "WaitlistTypeformModal-module__9N6xAW__modalRoot",
  "typeformContainer": "WaitlistTypeformModal-module__9N6xAW__typeformContainer",
});
